import React, { useState } from 'react';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import {
  FDAccordion,
  FDAccordionDetails,
  FDAccordionTitle,
  FDBox,
  FDClickableText,
  FDStack,
} from '@facet-wealth/design';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import {
  IncomeInformationSection,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/IncomeInformation/IncomeInformationSection';
import useMobileLayout from 'Hooks/useMobileLayout';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';


function IncomeAttestationLayout() {
  const [open, setOpen] = useState(false);
  const isMobile = useMobileLayout();
  useScrollTopOnMount();
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();

  return (
    <FDStack
      direction={'column'}
      spacing={4}
      alignItems={'center'}
    >
      <PageContentTop
        title={resource.attr('title')}
        subtitle={resource.attr('subtitle')}
      />
      <FDStack
        direction={'column'}
        spacing={2}
        width={'100%'}
      >
        <FDStack
          direction={isMobile ? 'column' : 'row'}
          spacing={isMobile ? 2 : 4}
          paddingX={2}
        >
          <MetaControlField attr={'earnedIncome'} />
          <MetaControlField attr={'passiveIncome'} />
        </FDStack>
        <FDAccordion expanded={open} onChange={() => setOpen(!open)}>
          <FDAccordionTitle>
            <FDStack direction={'row'} justifyContent={'center'} width={'100%'}>
              <FDBox width={'40px'} /> {/* This is used to offset the width of the down chevron in order to center the text in the accordion */}
              <FDClickableText
                appearance={'standalone'}
                label={'Review income details'}
              />
            </FDStack>
          </FDAccordionTitle>
          <FDAccordionDetails>
            <FDStack
              direction={'column'}
              spacing={2}
              alignItems={'center'}
              width={'100%'}
            >
              {resource.attr('clientIncomeInformation').resources().list().map((clientIncomeInfo) => (
                <IncomeInformationSection
                  key={clientIncomeInfo.id()}
                  clientIncomeInformationResource={clientIncomeInfo}
                />
              ))}
            </FDStack>
          </FDAccordionDetails>
        </FDAccordion>
      </FDStack>
      <MetaControlField attr={'attestsHighEarnedIncome'} />
      <MetaControlField attr={'attestsFutureHighEarnedIncome'} />
      <SurveyStepFooter
        onSubmit={onSubmitMetaForm}
      />
    </FDStack>
  );
}

IncomeAttestationLayout.propTypes = {};

IncomeAttestationLayout.defaultProps = {};

export { IncomeAttestationLayout };
